import {
  fetchDeliveryZoneById,
  fetchDeliveryZoneByZip,
} from '@/clients/pops/client'
import { DeliveryZone } from '@/models/delivery-zone'

import { setDeliveryZone, setPromise, setZipDeliveryZoneId } from './actions'
import { $getDeliveryZoneByZip } from './computed'
import { $deliveryZones, $promises } from './stores'

export const loadDeliveryZoneById = async ({
  deliveryZoneId,
}: {
  deliveryZoneId: number
}) => {
  if ($deliveryZones.get()[deliveryZoneId]) {
    return Promise.resolve()
  }

  const promiseKey = `loadDeliveryZoneById${deliveryZoneId}`
  if ($promises.get()[promiseKey]) {
    return $promises.get()[promiseKey]
  }

  const promise = (async () => {
    const rawDeliveryZone = await fetchDeliveryZoneById(deliveryZoneId)
    setDeliveryZone({
      deliveryZoneId,
      deliveryZone: new DeliveryZone(rawDeliveryZone),
    })
  })()

  setPromise({ promiseKey, promise })

  return promise
}

export const loadDeliveryZoneByZip = async (zip: string) => {
  const promiseKey = `loadDeliveryZoneByZip${zip}`
  if ($promises.get()[promiseKey]) {
    return $promises.get()[promiseKey]
  }

  const promise = (async () => {
    const rawDeliveryZone = await fetchDeliveryZoneByZip(zip)
    const deliveryZoneId = rawDeliveryZone.id

    setDeliveryZone({
      deliveryZoneId,
      deliveryZone: new DeliveryZone(rawDeliveryZone),
    })
    setZipDeliveryZoneId({ zip, deliveryZoneId })
  })()

  setPromise({ promiseKey, promise })

  return promise
}

export const isValidZip = async (zip: string) => {
  if (zip.length !== 5) return false

  try {
    await loadDeliveryZoneByZip(zip)
  } catch (error) {
    return false
  }

  return true
}

export const loadAndGetDeliveryZoneByZip = async (zip: string) => {
  try {
    await loadDeliveryZoneByZip(zip)
    return $getDeliveryZoneByZip.get()(zip)
  } catch (error) {
    return undefined
  }
}

export const getKitchenIdByZip = async (zip: string) => {
  try {
    const deliveryZone = await loadAndGetDeliveryZoneByZip(zip)
    return deliveryZone?.kitchen
  } catch (error) {
    return null
  }
}
